module.exports = __webpack_public_path__ + "static/logo-ali-0f680e24ea93132ba488a3c0710c8e9b.png";